export const WEEK_IN_TEXT = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

export const getPartialScheduleText = setting => {
  let text = '';
  if (setting.frequency === 'Daily') {
    text += `daily, every ${setting.cron.day} day(s)`;
  } else if (setting.frequency === 'Weekly') {
    text += `weekly, on ${WEEK_IN_TEXT[setting.cron.week]}`;
  } else {
    text += `every ${setting.cron.month} month(s), on day ${setting.cron.day}`;
  }
  return text;
};

export const getExpressionFromSetting = setting => {
  if (setting.frequency === 'Daily') {
    return `0 0 */${setting.cron.day} * *`;
  } else if (setting.frequency === 'Weekly') {
    return `0 0 * * ${setting.cron.week}`;
  } else {
    return `0 0 ${setting.cron.day} */${setting.cron.month} *`;
  }
};

export const getSettingFromExpression = text => {
  const schedules = text.split(' ');
  const [, , day, month, week] = schedules;
  const setting = {
    frequency: 'Daily',
    cron: {
      day: '1',
      month: '1',
      week: '1'
    },
    reportPeriod: 30
  };
  if (week !== '*') {
    setting.cron.week = +week;
    setting.frequency = 'Weekly';
  } else if (month === '*') {
    setting.frequency = 'Daily';
    setting.cron.day = +day.split('/')[1];
  } else {
    setting.frequency = 'Monthly';
    setting.cron.month = +month.split('/')[1];
    setting.cron.day = +day;
  }
  return setting;
};

export const STEP = {
  DEFAULT: 'DEFAULT',
  DEFAULT_CREATED: 'DEFAULT_CREATED',
  DEFAULT_EXIST: 'DEFAULT_EXIST',
  DEFAULT_DELETED: 'DEFAULT_DELETED',
  DEFAULT_UPDATED: 'DEFAULT_UPDATED',
  SETUP_FORM: 'SETUP_FORM',
  SETUP_CONFIRM: 'SETUP_CONFIRM',
  EDIT_FORM: 'EDIT_FORM',
  EDIT_CONFIRM: 'EDIT_CONFIRM',
  DELETE: 'DELETE'
};
export const STEPS = {
  [STEP.DEFAULT]: {
    title: "Get a report of your network's top offending IP addresses",
    showFooter: false
  },
  [STEP.DEFAULT_CREATED]: {
    title: "Get a report of your network's top offending IP addresses",
    showFooter: false
  },
  [STEP.DEFAULT_DELETED]: {
    title: "Get a report of your network's top offending IP addresses",
    showFooter: false
  },
  [STEP.DEFAULT_UPDATED]: {
    title: "Get a report of your network's top offending IP addresses",
    showFooter: false
  },
  [STEP.DEFAULT_EXIST]: {
    title: 'Report options',
    showFooter: false
  },
  [STEP.SETUP_FORM]: {
    title: 'Set up a recurring report',
    showFooter: true,
    okText: 'Next',
    backText: 'Back',
    backStep: STEP.DEFAULT,
    nextStep: STEP.SETUP_CONFIRM
  },
  [STEP.SETUP_CONFIRM]: {
    title: 'Set up a recurring report',
    showFooter: true,
    okText: 'Confirm',
    backText: 'Back',
    backStep: STEP.SETUP_FORM,
    nextStep: STEP.DEFAULT_CREATED
  },
  [STEP.EDIT_FORM]: {
    title: 'Edit report preferences',
    showFooter: true,
    okText: 'Next',
    backText: 'Back',
    backStep: STEP.DEFAULT_EXIST,
    nextStep: STEP.EDIT_CONFIRM
  },
  [STEP.EDIT_CONFIRM]: {
    title: 'Edit report preferences',
    showFooter: true,
    okText: 'Confirm',
    backText: 'Back',
    backStep: STEP.EDIT_FORM,
    nextStep: STEP.DEFAULT_UPDATED
  },
  [STEP.DELETE]: {
    title: 'Cancel recurring report',
    showFooter: true,
    okText: 'Confirm',
    backText: 'Cancel',
    backStep: STEP.DEFAULT_EXIST,
    nextStep: STEP.DEFAULT_DELETED
  }
};
